import { useSelector } from "react-redux"

export const useWorker = (id)=>{
    const workers = useSelector(state => state.workers.workers)
    return workers[id]?workers[id]:{working:false, done:false, error:''}
    
}